module.exports = __webpack_public_path__ + "img/video.050c50d3.png";